import { type ComponentProps, type FC } from 'react';

import clsx from 'clsx';

import { Button, type ButtonProps } from '@/components/common/button/Button';
import { Link } from '@/components/common/Link';

import styles from './ButtonLink.module.scss';

export type ButtonLinkProps = ButtonProps &
  Pick<ComponentProps<typeof Link>, 'href' | 'target' | 'rel'> & {
    isOutsideLink?: boolean;
  };

export const ButtonLink: FC<ButtonLinkProps> = (props) => {
  const { className, href, target, rel, isOutsideLink, ...buttonProps } = props;

  return (
    <Link className={clsx(styles.root, className)} href={href} target={target} rel={rel} isOutsideLink={isOutsideLink}>
      <Button className={styles.button} {...buttonProps} />
    </Link>
  );
};
